
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/hooks/use-toast";
import { Mail, Check } from "lucide-react";

const NewsletterAndAffiliates: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: "Error",
        description: "Please enter your email address",
        variant: "destructive",
      });
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: "f73833ab-235f-473d-b803-999eb6905e43",
          name,
          email,
          subject: "New Blog Newsletter Subscription from Armpits.com",
          from_name: "Armpits.com Blog Newsletter",
          to_email: "info@fijidigital.com",
        }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setName("");
        setEmail("");
        toast({
          title: "Success!",
          description: "Thank you for subscribing to our newsletter!",
          variant: "default",
        });
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Something went wrong. Please try again later.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-10 md:py-16 bg-mint-50">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-bold mb-2 md:mb-3">Never Miss an Article</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Subscribe to our newsletter for the latest armpit health tips, research updates, and expert advice.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3 max-w-xl mx-auto mb-8 md:mb-12">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-grow">
              <Input
                type="text"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="pl-9 py-3 bg-background"
              />
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground">
                <Mail className="h-4 w-4" />
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-grow">
              <Input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="pl-9 py-3 bg-background"
              />
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground">
                <Mail className="h-4 w-4" />
              </div>
            </div>
            <Button 
              type="submit" 
              className="button-hover"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                "Subscribing..."
              ) : (
                <>
                  Subscribe <Check className="ml-1 h-4 w-4" />
                </>
              )}
            </Button>
          </div>
        </form>
        
        <div className="mt-8 md:mt-12">
          <h3 className="text-xl font-bold text-center mb-4 md:mb-6">Products We Recommend</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a href="https://itjustworksdeodorant.com?sca_ref=8468108.vEEWUNzhD1" target="_blank" rel="noopener noreferrer" className="block p-4 border border-input rounded-lg bg-background hover:bg-accent pulse-on-hover hover-card">
              <h4 className="font-medium">It Just Works Deodorant</h4>
              <p className="text-sm text-muted-foreground">Natural deodorant that actually works. Try it today!</p>
            </a>
            <a href="https://www.skillano-beauty.com/?ref=sfvnconi" target="_blank" rel="noopener noreferrer" className="block p-4 border border-input rounded-lg bg-background hover:bg-accent pulse-on-hover hover-card">
              <h4 className="font-medium">Skillano Beauty</h4>
              <p className="text-sm text-muted-foreground">Premium skincare products for your underarm health.</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterAndAffiliates;
